import React, { useRef } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { UserPostImageUpload, VideoImageUpload, VideoUpload } from "..";

type ImageUpdateProps = {
  imageUpload: string[];
  handleImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  totalImages: number;
  handleCloseCreate: () => void;
  setShowAllImages: React.Dispatch<React.SetStateAction<number | null>>;
  handleClick: (index: number) => void;
  imageLoading?: boolean;
  onVideoSelectFile: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => Promise<void>;
  selectedVideos: string[];
  totalVideos: number;
  allMediaUrls: string[];
  thumbnail?: string[];
};
const ImageUpdate: React.FC<ImageUpdateProps> = ({
  imageUpload,
  handleImageChange,
  totalImages,
  handleCloseCreate,
  setShowAllImages,
  handleClick,
  imageLoading,
  onVideoSelectFile,
  selectedVideos,
  totalVideos,
  allMediaUrls,
  thumbnail,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleIconClick = () => {
    fileInputRef.current!.click();
  };

  return (
    <div
      className={`w-full h-[186px] transition-all ease-linear duration-700 border border-[#D9E2E3] rounded-[10px] bg-[#F4F4F4] flex items-center justify-center relative p-1 overflow-y-auto ${
        imageUpload?.length >= 4 && allMediaUrls.length && "pt-[63%]"
      } ${selectedVideos.length > 3 && "pt-0"}`}
    >
      {!imageUpload?.length && !selectedVideos?.length && (
        <div
          onClick={handleIconClick}
          className="text-center w-[115px] flex flex-col font-Poppins text-xs font-normal text-[#1A202C] cursor-pointer"
        >
          Browse
          <span className="text-lightGreen">Photos / Videos</span>
        </div>
      )}
      {imageUpload?.length === 0 && selectedVideos.length === 0 && (
        <div
          className="flex bg-white items-center justify-center rounded-full h-8 w-8 absolute cursor-pointer top-1 right-2"
          onClick={() => handleCloseCreate()}
        >
          <AiOutlineClose size={20} />
        </div>
      )}

      {((imageUpload && imageUpload.length > 0) ||
        selectedVideos.length > 0) && (
        <div className="flex gap-1 shadow-sm h-7 items-center px-2 bg-white rounded-lg absolute top-1 left-2 z-10">
          <div
            className="font-Poppins font-semibold cursor-pointer text-[15px] text-midGreen"
            onClick={handleIconClick}
          >
            Add photos /Videos
          </div>
        </div>
      )}

      <input
        type="file"
        ref={fileInputRef}
        accept="image/*, video/*, application/pdf"
        multiple
        onChange={(e) => {
          const file = e.target.files?.[0]; // Assuming you're selecting only one file at a time
          if (file) {
            if (file.type.startsWith("image/")) {
              handleImageChange(e);
            } else if (file.type.startsWith("video/")) {
              onVideoSelectFile(e);
            }
          }
        }}
        className="invisible hidden"
      />

      <div className={`${imageUpload?.length && selectedVideos?.length && 'w-full h-full'}`}>
        {imageUpload.length > 0 && selectedVideos.length > 0 ? (
          <VideoImageUpload
            imageUpload={imageUpload}
            selectedVideos={selectedVideos}
            setShowAllMedia={setShowAllImages}
            allMediaUrls={allMediaUrls}
            handleClick={handleClick}
            thumbnail={thumbnail}
          />
        ) : imageUpload && imageUpload?.length > 0 && !selectedVideos.length ? (
          <UserPostImageUpload
            imageUpload={imageUpload}
            totalImages={totalImages}
            handleClick={handleClick}
            setShowAllImages={setShowAllImages}
            imageLoading={imageLoading}
          />
        ) : (
          selectedVideos &&
          selectedVideos?.length > 0 && (
            <VideoUpload
              selectedVideos={selectedVideos}
              totalVideos={totalVideos}
              handleClick={handleClick}
              setShowAllMedia={setShowAllImages}
              thumbnail={thumbnail}
            />
          )
        )}
      </div>
    </div>
  );
};

export default ImageUpdate;
